/**
 * Chart data view settings keys
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/service/WorkbookSettingsConstants.java
 */
export const CHART_DATA_VIEW_KEYS = {
  CHART_BREAK_AXIS_ON: 'chart.breakAxis.enabled',
  CHART_VALUE_LABELS_ON: 'chart.valueLabels.enabled',
  /**
   * If "clip" (default), cut off the chart data at the limit set by AbstractChartVisualization#getMaxDataRecords.
   * If "zoom", instead display up to 100.000 data points (or, if the query limit is lower, up to the query limit),
   * and limit the data points visible at the same time in the chart to AbstractChartVisualization#getMaxDataRecords
   * by preventing the chart from being zoomed out completely.
   */
  CHART_MAX_DATA_RECORDS_STRATEGY: 'chart.maxDataRecordsStrategy',
  /** Keys for the bundle attribute maximum data view settings. */
  LINE_CHART_MAX_MEASURES: 'chart.lineChart.maxMeasures',
  MULTI_LINE_CHART_MAX_MEASURES: 'chart.multiLineChart.maxMeasures',
  PIE_CHART_MAX_MEASURES: 'chart.pieChart.maxMeasures',
  BAR_CHART_MAX_MEASURES: 'chart.barChart.maxMeasures',
  HUNDRED_PERCENT_BAR_CHART_MAX_MEASURES: 'chart.hundredPercentBarChart.maxMeasures',
  STACKED_BAR_CHART_MAX_MEASURES: 'chart.stackedBarChart.maxMeasures',
  GROUPED_BAR_CHART_MAX_MEASURES: 'chart.groupedBarChart.maxMeasures',
  COLUMN_CHART_MAX_MEASURES: 'chart.columnChart.maxMeasures',
  HUNDRED_PERCENT_COLUMN_CHART_MAX_MEASURES: 'chart.hundredPercentColumnChart.maxMeasures',
  STACKED_COLUMN_CHART_MAX_MEASURES: 'chart.stackedColumnChart.maxMeasures',
  GROUPED_COLUMN_CHART_MAX_MEASURES: 'chart.groupedColumnChart.maxMeasures',
  PIE_CHART_POINT_MAX_MEASURES: 'map.pieChartPoint.maxMeasures',
  MEASUREMENT_CLASSIFICATION_POLYGON_WITH_PIE_CHART_MAX_MEASURES: 'map.measurementClassificationPolygonWithPieChart.maxMeasures',
  DIMENSION_CLASSIFICATION_POLYGON_WITH_PIE_CHART_MAX_MEASURES: 'map.dimensionClassificationPolygonWithPieChart.maxMeasures'
};

/**
 * Provide default values for backwards compatibility. (e.g. for DataViews that have been created
 * before bundle attribute limiting was implemented.)
 *
 * @see net/disy/cadenza/workbook/access/command/dataview/AddDataViewCommandExecutor.java
 * @see net/disy/cadenza/selection/api/config/PivotTableConfiguration.java
 */
export const CHART_BUNDLE_ATTRIBUTE_LIMIT_DEFAULTS = {
  FALLBACK: 10
};

/**
 * Chart data view settings values
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/service/WorkbookSettingsConstants.java
 */
export const CHART_DATA_VIEW_VALUES = {
  CHART_MAX_DATA_RECORDS_STRATEGY_CLIP: 'clip',
  CHART_MAX_DATA_RECORDS_STRATEGY_ZOOM: 'zoom'
};
